import React, { useContext } from 'react';
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { CrossIcon } from "../../../internal/icons/CrossIcon";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../Modal.styles";
export function ModalClose(_ref) {
  var _cx;

  var disableClose = _ref.disableClose,
      requestClose = _ref.requestClose;
  var theme = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement("button", {
    className: cx((_cx = {}, _cx[styles.close(theme)] = true, _cx[styles.disabled(theme)] = disableClose, _cx)),
    onClick: requestClose,
    "data-tid": "modal-close"
  }, /*#__PURE__*/React.createElement(CrossIcon, null));
}